import { AxiosInstanceProvider } from '../../../core/hooks';
import { CustomersHttpQuery } from '../../config';
import { CustomerApiModel } from '../../model';

export type CustomersHttpGetResponseModel = CustomerApiModel[];

export const getCustomers = async (axios: AxiosInstanceProvider): Promise<CustomersHttpGetResponseModel> => {
  const response = await axios().get<CustomersHttpGetResponseModel>(CustomersHttpQuery['GetCustomers'].url);
  return response.data;
};

